import uEmojiParser from "universal-emoji-parser";

type ParseEmoji = (emojiUnicode: string) => string;

const parseEmoji: ParseEmoji = (emojiUnicode) => {
  return uEmojiParser.parse(emojiUnicode);
};

export default parseEmoji;
